// ROGA VARIABLES

const ROGA_DEV = "http://localhost:3000/api/v1";
// const ROGA_DEV = 'https://roga.docgo.com.br/api/v1';
const ROGA_PROD = "https://homologacao.docgo.com.br/api/v1";
const IMA_PROD = "https://api.ima.docgo.com.br/api/v1";
const PENEDO_PROD = "https://api.penedo.docgo.com.br/api/v1";
const PENEDO_HOMOLOG = "https://api.homolog.penedo.docgo.com.br/api/v1";
const MARECHAL_PROD = "https://api.marechal.docgo.com.br/api/v1";
const TEOTONIO_PROD = "https://api.teotonio.docgo.com.br/api/v1";
const HOMOLOG = "https://api.homolog.docgo.com.br/api/v1";

const API_URL = () => {
  switch (location.hostname) {
    case "localhost":
      return HOMOLOG;
    case "homologacao.docgo.com.br":
      return HOMOLOG;
    case "ima.docgo.com.br":
      return IMA_PROD;
    case "penedo.docgo.com.br":
      return PENEDO_PROD;
    case "homolog.penedo.docgo.com.br":
      return PENEDO_HOMOLOG;
    case "marechal.docgo.com.br":
      return MARECHAL_PROD;
    case "teotonio.docgo.com.br":
      return TEOTONIO_PROD;
    case "homolog.docgo.com.br":
      return HOMOLOG;
    default:
      return ROGA_DEV;
  }
};

export default API_URL;



// WEBPACK FOOTER //
// ./src/constants/API_URL.js